import type { Project, User } from "../types";

type ArchiveActor = Pick<User, "role" | "permissions">;

export function canArchiveProject(
  user: Partial<ArchiveActor> | null | undefined,
): boolean {
  return Boolean(
    user?.role === "admin" ||
      user?.permissions?.includes("*") ||
      user?.permissions?.includes("project.archive"),
  );
}

export function activeProjects(projects: Project[]): Project[] {
  return projects.filter((project) => !project.archivedAt);
}

export function archivedProjects(projects: Project[]): Project[] {
  return projects.filter((project) => Boolean(project.archivedAt));
}
